<template>
  <hm-content title="">
    <div class="mb10  flex flex-end">
      <el-input
        style="width:280px"
        clearable
        v-model.trim="searchCondition.keyWords"
        placeholder="请输入会员手机号/会员卡号/会员姓名"
        size="small"
        class="ipt mr10"
      >
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small">导出</el-button>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员手机号"
          prop="handleTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员卡号"
          prop="memberDistinctNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="platformPromotionAmount"
          label="会员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="platformPromotionAmount"
          label="金豆合计"
        >
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="detail(scope.row, 'data', '金豆数据')"
              >
                金豆数据
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="detail(scope.row, 'edit', '变更记录')"
              >
                变更记录
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div v-if="type === 'data'">
        <el-table
          :data="list"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="table"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="handleTime"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆值"
            prop="memberDistinctNum"
          ></el-table-column>
        </el-table>
      </div>
      <div v-else>
        <div class="mb20 flex flex-end">
          <el-select
            clearable
            v-model="searchConditionDialog.shopId"
            placeholder="请选金豆别称"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in shopList"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            clearable
            v-model="searchConditionDialog.shopIds"
            placeholder="请选择变更操作"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in shopList"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            clearable
            v-model.trim="searchConditionDialog.keyWords"
            placeholder="请输入订单号"
            size="small"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="searchDetail"
            >查询</el-button
          >
        </div>
        <el-table
          :data="list"
          style="width: 100%"
          stripe
          size="small"
          border
          ref="table"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更操作"
            prop="handleTime"
          >
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                title="标题"
                width="200"
                trigger="click"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
              >
                <div slot="reference">click 激活</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="交易订单号"
            prop="memberDistinctNum"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆别称"
            prop="memberDistinctNum"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金豆变化"
            prop="memberDistinctNum"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="变更时间"
            prop="memberDistinctNum"
          ></el-table-column>
        </el-table>
      </div>

      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalDetail"
          @current-change="pagingDetail"
          @size-change="handleSizeChangeDetail"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageDetail"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      shopList: [],
      detailList: [{}],
      totalDetail: 0,
      currentPageDetail: 1,
      pageSizeDetail: 10,
      searchConditionDialog: {},
      title: "",
      dialogVisible: false,
      ruleForm: {
        categoryName: "",
        categoryPrice: "",
        categoryRadio: "",
        categoryMultiple: "",
        applyDate: ""
      },
      rules: {
        categoryName: [
          {
            required: true,
            trrger: "change",
            message: "请输入金豆别称"
          },
          { max: 5, message: "长度在5个字符内", trigger: "change" }
        ],
        categoryPrice: {
          required: true,
          trrger: "change",
          message: "请输入金额"
        },
        categoryRadio: {
          required: true,
          trrger: "change",
          message: "请输入金豆数量"
        },
        categoryMultiple: {
          required: true,
          trrger: "change",
          message: "请输入整数"
        },
        applyDate: {
          required: true,
          trrger: "change",
          message: "请输入时间段"
        }
      },
      list: [{}],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      type: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    searchDetail() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.ruleForm[prop] = new Number(this.ruleForm[prop]);
    },
    add() {
      this.$router.push({
        name: "SettingFortunellaVenosaRule",
        query: {
          type: "add"
        }
      });
    },
    async save() {
      const { valid } = await this.$refs.ruleForm.validate();
      if (valid) {
      } else {
        return;
      }
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {});
      if (result === "confirm") {
        console.log("result: ", result);
      }
    },
    detail(row, type, title) {
      this.title = title;
      this.row = row;
      this.type = type;
      this.dialogVisible = true;
    },
    async queryDetailList() {
      const params = {
        pageSize: this.pageSizeDetail,
        pageNo: this.currentPageDetail
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDialog)
      );
      Object.assign(params, searchCondition);
      let name = this.type === "data" ? "" : "";
      const { code, result } = await this.$store.dispatch(name, params);
      if (code === "0") {
        const { total, records } = result;
        this.detailList = records;
        this.totalDetail = total;
      }
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    },

    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
